/* eslint-disable */
import React from 'react';
import { Spin } from 'antd';
import './Loader.css'; // Make sure to create this CSS file as before

const ScreenLoader = () => (
  <div className="full-screen-loader">
    <Spin size="large" />
  </div>
);

export default ScreenLoader;
